// extracted by mini-css-extract-plugin
export default {"root":"IconBank_root__f1ZeL","icon":"IconBank_icon__SHz7x"};